import './list.scss';
import {Paragraph} from "../Paragraph";
import type { ListProps } from "./List.interface";

/**
 * Primary UI component for user interaction
 */
export function List(props:ListProps) {


  function ListContent() {
    return props.subitems.map((child, index) => {
      const idAndKey = props.id ? props.id + "-" + index.toString() : "list" + index;
      return <>
        <li key={idAndKey} id={idAndKey} >{child}</li>
        {
            props.useBreaksBetweenItems && <br/>
        }
      </>;
    });
  }

  return (
      <div className={"listWrapper"}>
        {props.intro && <Paragraph text={props.intro}/>}
        {props.type === "unordered" ? 
            <ul aria-label={props.id} id={props.id} key={props.id} className={props.className}>
             <ListContent />
            </ul>
            :
            <ol aria-label={props.id} id={props.id} key={props.id} className={props.className}>
              <ListContent />
            </ol>
        }
      </div>
  );
}